import React from 'react';

import { Artwork as ArtworkCell } from '../common/container/Cell.jsx';
import { ArtworkGridContainer, Spaced } from '../common/container/Container.jsx';
import { default as FilterContainer } from '../common/container/Filter.jsx';
import { Indicator as LoadingIndicator } from '../common/container/Loading.jsx';
import { ListArtworkAdd } from '../common/container/Popup.jsx';

let _LabelsInst;
class Labels extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            artwork: {
                loading: false,
                q: {
                    dir: 1,
                    limit: 20,
                    offset: 0,
                    order: 2
                }
            }
        };

        this.sortOptions = [
            { display: 'Popular', value: 0 },
            // { display: 'Following', value: 1 },
            { display: 'Newest', value: 2 },
            { display: 'Suggested', value: 3 }
        ];

        this.getArtwork = this.getArtwork.bind(this);
        this.handleArtworkLikeChange = this.handleArtworkLikeChange.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleFilterHide = this.handleFilterHide.bind(this);
        this.handleFilterShow = this.handleFilterShow.bind(this);
        this.handleListArtworkAddModalClose = this.handleListArtworkAddModalClose.bind(this);
        this.handleWaypointEnter = this.handleWaypointEnter.bind(this);
    }

    componentDidMount() {
        _LabelsInst = true;
        this.getArtwork();
    }

    componentWillUnmount() {
        _LabelsInst = undefined;

        if (this.artworkRequest) {
            this.artworkRequest.abort();
            this.artworkRequest = null;
        }
    }

    getArtwork() {
        const component = this;
        const state = component.state.artwork;
        if (state.loading) {
            return;
        }
        state.loading = true;
        component.setState({
            artwork: state
        });
        const query = { ...state.q };
        let item, data;
        for (let id in query) {
            data = query[id];
            if (!data) {
                continue;
            }
            if (data.value != undefined) {
                query[id] = data.value;
                continue;
            }
            if (!Array.isArray(data)) {
                continue;
            }
            if (data.length == 1) {
                item = data[0];
                query[id] = item.value;
            } else {
                for (let i = 0; i < data.length; i++) {
                    item = data[i];
                    query[`${id}[${i}]`] = item.value;
                }
                query[id] = undefined;
            }
        }
        component.artworkRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.art.get(),
            query,
            function (responseData) {
                component.artworkRequest = null;

                responseData.Data.forEach(function (d) {
                    Artcloud.mkt.art._isfavorite(d);
                });

                let data = state.data || [];
                state.data = data.concat(responseData.Data);
                state.q.offset += responseData.Data.length;
                state.hasMore = responseData.HasMore;

                state.loading = false;
                component.setState({
                    artwork: state
                });
            },
            function (jqXHR, textStatus) {
                component.artworkRequest = null;

                state.loading = false;
                component.setState({
                    artwork: state
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    handleArtworkLikeChange(d) {
        const state = this.state.artwork;
        let artwork;
        for (let i = 0; i < state.data.length; i++) {
            let temp = state.data[i];
            if (!temp || temp.ArtId != d.ArtId) {
                continue;
            }
            artwork = temp;
            break;
        }
        if (!artwork) {
            return;
        }
        const component = this;
        Artcloud.mkt.art.updateFavorite(artwork.ArtId, !artwork.IsFavorite, artwork.Title, function () {
            if (!_LabelsInst) {
                return;
            }
            artwork.IsFavorite = !artwork.IsFavorite;
            component.setState({
                artwork: state,
                listArtworkAddModal: {
                    data: artwork,
                    visible: true
                }
            });
        });
    }

    handleFilterChange(name, value, refresh) {
        if (this.artworkRequest) {
            this.artworkRequest.abort();
            this.artworkRequest = null;
        }
        const state = this.state.artwork;
        switch (name) {
            case 'search':
                this.setState({
                    [name]: value
                });
                return;
            case 'label':
                let list;
                if (value != undefined) {
                    list = state.q[name] || [];
                    let removed = false;
                    let temp;
                    for (let i = 0; i < list.length; i++) {
                        temp = list[i];
                        if (temp.value == value.value) {
                            list.splice(i, 1);
                            removed = true;
                            break;
                        }
                    }
                    if (!removed) {
                        list.push(value);
                    }
                }
                state.q[name] = list;
                break;
            default:
                state.q[name] = value;
                break;
        }
        state.data = undefined;
        state.hasMore = undefined;
        state.q.offset = 0;

        const component = this;
        this.setState({
            artwork: state
        }, function () {
            Artcloud.storage.put(Artcloud.storage.keys.browse, state.q);

            if (refresh != false) {
                component.getArtwork();
            }
        });
    }

    handleFilterHide(event) {
        if (event) {
            event.preventDefault();
        }
        this.setState({
            filterVisible: false
        });
    }

    handleFilterShow(event) {
        if (event) {
            event.preventDefault();
        }
        this.setState({
            filterVisible: true
        });
    }

    handleListArtworkAddModalClose() {
        this.setState({
            listArtworkAddModal: undefined
        });
    }

    handleWaypointEnter() {
        if (!this.state.artwork.data || (this.state.artwork.data && this.state.artwork.hasMore == false)) {
            return;
        }
        this.getArtwork();
    }

    render() {
        let filterClassName = 'sidebar__container sidebar--filter';
        if (this.state.filterVisible) {
            filterClassName += ' sidebar--filter--active';
        }
        return (
            <React.Fragment>
                <div className="container--sidebar__outer">
                    <Spaced className="container--sidebar-left">
                        <div className={filterClassName}>
                            <a href="#" className="btn btn--save btn--outline btn--light" onClick={this.handleFilterHide}>Apply Filter</a>
                            <div className="control__holder" onClick={this.handleFilterHide}>
                                <div className="icon__holder icon--close">
                                    <div className="icon__inner">
                                        <div className="icon__bar" />
                                        <div className="icon__bar" />
                                        <div className="icon__bar" />
                                    </div>
                                </div>
                            </div>
                            <h5 className="sidebar__title">Browse artwork</h5>
                            <FilterContainer
                                filters={this.state.artwork.q}
                                renderOptions={{ labels: true, search: true }}
                                search={this.state.search}
                                sortOptions={this.sortOptions}
                                onChange={this.handleFilterChange} />
                        </div>
                        <div className="show--m text--center">
                            <h2 className="sidebar__title">Browse artwork</h2>
                        </div>
                        <a href="#" className="btn btn--outline btn--fulwidth btn--dark filter--button show--m" onClick={this.handleFilterShow}>
                            <span className="i i--filter" />
                            <React.Fragment>&nbsp;Filter</React.Fragment>
                        </a>
                        <div className="container__row" style={{ minHeight: '3300px' }}>
                            <div>
                                {
                                    this.state.artwork.data &&
                                    this.state.artwork.data.length == 0 &&
                                    <div className="blank__cont blank--fill blank--single blank--witharr">
                                        <p className="blank__text">No results. Try removing filters.</p>
                                    </div>
                                }
                                <ArtworkGridContainer id="art" sizeClassName="art__container art--adapt grid--4" onWaypointEnter={this.handleWaypointEnter}>
                                    {
                                        this.state.artwork.data &&
                                        this.state.artwork.data.length > 0 &&
                                        this.state.artwork.data.map((d) => <ArtworkCell key={d.ArtId} className="grid--4" d={d} onLikeChange={this.handleArtworkLikeChange} cols={3} />)
                                    }
                                </ArtworkGridContainer>
                                {
                                    this.state.artwork.loading &&
                                    <LoadingIndicator />
                                }
                            </div>
                        </div>
                    </Spaced>
                </div>
                {
                    this.state.listArtworkAddModal &&
                    this.state.listArtworkAddModal.visible &&
                    <ListArtworkAdd data={this.state.listArtworkAddModal.data} onClose={this.handleListArtworkAddModalClose} />
                }
            </React.Fragment>
        );
    }
}

export default Labels;